<template>
  <div class="depa_view">
    <h2>4、科室考试情况</h2>
    <h3>4.1、科室考试排名</h3>
    <p>
      共 <span>{{ $parent.fourData.length }}</span> 个科室参与,
      已考科室人按照"参与率"和"平均成绩"综合排名前10如下"：
    </p>
    <div class="depa_table">
      <div class="select_view">
        <p>分页选择：</p>
        <el-select v-model="paging" placeholder="请选择" @change="changPaging">
          <el-option
            v-for="item in pagingArr"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <el-table
        :data="depaData"
        border
        style="width: 100%"
        :height="$parent.rolling == true ? 541 : ''"
        :header-cell-style="{
          'background-color': '#8FCBFF',
          color: '#333333',
          height: '60px',
          'text-align': 'center'
        }"
      >
        <el-table-column label="排名" type="index" width="100">
        </el-table-column>
        <el-table-column
          v-for="(item, index) in formColumns"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          :width="item.width"
          height="150"
          label-height="50"
          align="center"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
      </el-table>
    </div>
    <DepartSon ref="DepartSon" />
    <h3 @click="filterData">4.2、未参与考试的科室</h3>
    <p>未参与科室：{{ ment }}</p>
    <!-- 第五部分 -->
    <h2>5、岗位考试情况(职称考试情况)</h2>
    <p>
      共{{ $parent.fiveData.length }}个职称参与,按照"参与率"综合排名前10如下
    </p>
    <div class="jobs_view">
      <p>职称考试情况</p>
      <div class="select_view">
        <p>分页选择：</p>
        <el-select v-model="jobs" placeholder="请选择" @change="jbsChang">
          <el-option
            v-for="item in pagingArr"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <div class="table_view">
        <el-table
          :data="jobsData"
          border
          style="width: 100%"
          :height="$parent.rolling == true ? 541 : ''"
          :header-cell-style="{
            'background-color': '#8FCBFF',
            color: '#333333',
            height: '60px',
            'text-align': 'center'
          }"
        >
          <!-- <el-table-column label="排名" type="index" width="100"> -->
          <!-- </el-table-column> -->
          <el-table-column
            v-for="(item, index) in jobColumns"
            :key="index"
            :prop="item.prop"
            :label="item.label"
            :width="item.width"
            height="150"
            label-height="50"
            align="center"
            :show-overflow-tooltip="true"
          >
          </el-table-column>
        </el-table>
      </div>
    </div>
    <DepartSon ref="DepartSo12" />
    <!-- 第六部分 -->

  </div>
</template>

<script>
import test from "./test";
import DepartSon from "./DepartSon.vue";
import { columnarOne, columnarTwo } from "./charts";
export default {
  components: {
    DepartSon
  },
  data() {
    return {
      depaData: [],
      formColumns: [
        {
          prop: "DepartmentName",
          label: "科室"
        },
        {
          prop: "allUserCount",
          label: "总考试人数"
        },
        {
          prop: "AlreadyStuCount",
          label: "已考人数"
        },
        {
          prop: "cyl1",
          label: "参与率"
        },
        {
          prop: "jgl1",
          label: "及格率"
        },
        {
          prop: "fullStuCount",
          label: "满分人数 (包含及格人数)",
          width: 180
        },
        {
          prop: "PassStuCount",
          label: "及格人数"
        },
        {
          prop: "NoPassStuCount",
          label: "不及格人数"
        },
        {
          prop: "averageScore",
          label: "平均成绩(分)"
        }
      ],
      paging: "null",
      jobs: "null", // 岗位
      pagingArr: [
        {
          value: "null",
          label: "全部"
        },
        {
          value: "10",
          label: "10"
        },
        {
          value: "20",
          label: "20"
        },
        {
          value: "50",
          label: "50"
        }
      ],
      ment: "",
      jobsData: [], // 岗位
      jobColumns: [
        {
          prop: "Ptitle",
          label: "职称"
        },
        {
          prop: "allUserCount",
          label: "总考试人数"
        },
        {
          prop: "AlreadyStuCount",
          label: "已考人数"
        },
        {
          prop: "cyl1",
          label: "参考率"
        }
      ],
  
      newArr: []
    };
  },
  methods: {
    // 分页展示
    changPaging(a) {
      if (a == "null") {
        this.depaData = this.$parent.fourData;
        this.reportData();
      } else {
        console.log(a, "默认执行了");
        this.depaData = this.$parent.fourData.slice(0, a);
        this.reportData();
      }
    },
    // 岗位分页
    jbsChang(a) {
      if (a == "null") {
        this.jobsData = this.$parent.fiveData;
        this.jobsReportData();
      } else {
        console.log(a, "默认执行了");
        this.jobsData = this.$parent.fiveData.slice(0, a);
        this.jobsReportData();
      }
    },

    // 筛选出未参加考试的科室
    filterData() {
      let arr = this.depaData.filter(item => {
        return item.AlreadyStuCount == 0; // 过滤出未参与考试的科室
      });
      let head = arr.map(item => {
        return item.DepartmentName;
      });

      this.ment = head.length != 0 ? head.join("、") : "无";
    },
    // 接口四科室的柱状图
    async reportData() {
      this.$nextTick(() => {
        columnarOne.xAxis[0].data = this.depaData.map(item => {
          return item.DepartmentName; // 科室
        });
        columnarOne.series[0].data = this.depaData.map(item => {
          return item.averageScore; // 平均成绩
        });
        columnarOne.series[1].data = this.depaData.map(item => {
          return item.jgl; // 参与率
        });
        this.$refs.DepartSon.init(columnarOne);
      });
    },
    // 接口五岗位柱状图
    async jobsReportData() {
      this.$nextTick(() => {
        columnarTwo.xAxis[0].data = this.jobsData.map(item => {
          return item.Ptitle; // 科室
        });
        columnarTwo.series[0].data = this.jobsData.map(item => {
          return item.AlreadyStuCount; // 参考人数
        });
        columnarTwo.series[1].data = this.jobsData.map(item => {
          return item.cyl; // 参考率
        });
        this.$refs.DepartSo12.init(columnarTwo);
      });
    }
  },

};
</script>

<style lang="scss" scoped>
.depa_view {
  h2 {
    margin-top: 32px;
  }
  h3 {
    margin-top: 26px;
  }
  p {
    margin-top: 16px;
    letter-spacing: 2px;
    span {
      color: red;
    }
  }
  .depa_table {
    margin-top: 26px;
  }
}
::v-deep .el-table th.el-table__cell > .cell {
  text-align: center;
}
::v-deep .el-table td.el-table__cell div {
  text-align: center;
}
::v-deep .el-table .cell {
  text-align: center;
}
.select_view {
  display: flex;
  align-items: center;
  margin-bottom: 24px;
  p {
    margin: 0 !important;
  }
}
.jobs_view {
  p {
    margin: 0 !important;
    text-align: center;
  }
}
.table_view {
  padding: 0 300px;
}
</style>
